import { useState } from "react"
import cn from "classnames"
import richText from "utilities/richText"
import Chevron from "public/assets/chevron-teal.svg"

export default function AccordionItem({ blok: { title, content }, blok }) {
  const [expanded, setExpanded] = useState(false)

  const dynamicContent = cn(
    "faq-section-content leading-loose w-full transition-all origin-top break-words prose max-w-none rounded-b-10 bg-white shadow",
    {
      "max-h-0 scale-y-0 opacity-0 p-0": !expanded,
      "max-h-full scale-y-1 opacity-1 p-4 lg:p-8": expanded,
    },
  )

  const titleStyles = cn(
    "flex cursor-pointer flex-row items-center justify-between gap-x-4 bg-stone-mid p-4 lg:px-8 shadow",
    {
      "rounded-10": !expanded,
      "rounded-t-10": expanded,
    },
  )

  return (
    <div className="mx-auto my-6 w-full">
      <div className={titleStyles} onClick={() => setExpanded(!expanded)}>
        <h3
          className={cn({
            "m-0 grow font-secondary text-l1 font-medium text-gray lg:text-l2": true,
            "max-w-3xl text-m2 lg:text-m2": blok.component === "faq_item",
          })}
        >
          {title}
        </h3>
        <button onClick={() => setExpanded(!expanded)} className="faq-section-btn" aria-label="toggle accordion state">
          <Chevron
            className={cn({
              "rotate-180 transition duration-300": expanded,
              "rotate-0 transition duration-300": !expanded,
            })}
          />
        </button>
      </div>
      <div className={dynamicContent} inert={!expanded ? "" : null}>
        {richText(content)}
      </div>
    </div>
  )
}
